import { render, staticRenderFns } from "./DefineTheme.vue?vue&type=template&id=1018bc08&scoped=true&"
import script from "./DefineTheme.vue?vue&type=script&lang=js&"
export * from "./DefineTheme.vue?vue&type=script&lang=js&"
import style0 from "./DefineTheme.vue?vue&type=style&index=0&id=1018bc08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1018bc08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1018bc08')) {
      api.createRecord('1018bc08', component.options)
    } else {
      api.reload('1018bc08', component.options)
    }
    module.hot.accept("./DefineTheme.vue?vue&type=template&id=1018bc08&scoped=true&", function () {
      api.rerender('1018bc08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/form/theme/components/DefineTheme.vue"
export default component.exports